import { useSelector } from 'react-redux';
import { SellerProperties } from '../../../../store/seller/seller-properties';

export const useIsInventoryEnabled = () => {
  const { isInventoryEnabled } = useSelector((state) => new SellerProperties({ state }));
  return isInventoryEnabled;
};
